// 「我的订单」页签传递工具。
// 不再把 dataType 拼到 URL 上：微信会对 /myorder?dataType=delivery 这类历史链接做安全拦截，
// 改为用 sessionStorage 在页面间传递页签，地址栏始终是干净的 /myorder。
// 读取后立即清除，避免下次进入订单页时残留上一次的页签。
const ORDER_TAB_KEY = 'happy_shopping_order_tab'

// 与 myorder 页面 data.active 的取值保持一致
const VALID_TABS = ['all', 'payment', 'delivery', 'received', 'comment', 'refund']

// 保存待打开的订单页签
export function saveOrderTab (tab) {
  if (VALID_TABS.indexOf(tab) === -1) return
  try {
    sessionStorage.setItem(ORDER_TAB_KEY, tab)
  } catch (e) {
    // 忽略存储异常
  }
}

// 读取并清除待打开的订单页签；无有效值时返回空字符串
export function readOrderTab () {
  try {
    const tab = sessionStorage.getItem(ORDER_TAB_KEY)
    sessionStorage.removeItem(ORDER_TAB_KEY)
    return VALID_TABS.indexOf(tab) === -1 ? '' : tab
  } catch (e) {
    return ''
  }
}
